import * as Yup from 'yup';
import { MESSAGE_ERREUR_3CARACTERES_MINIMUM } from '../../data/message-erreurs-form';




export const NoticesFilterSchema = Yup.object().shape({
  Collection: Yup
    .string()
    .transform((value, originalValue) => originalValue ? originalValue.trim() : value)
    .test('min-length', MESSAGE_ERREUR_3CARACTERES_MINIMUM, (value) => !value || value.length >= 3)
    .defined(),
  Auteur: Yup
    .string()
    .transform((value, originalValue) => originalValue ? originalValue.trim() : value)
    .test('min-length', MESSAGE_ERREUR_3CARACTERES_MINIMUM, (value) => !value || value.length >= 3)
    .defined(),
  Titre: Yup
    .string()
    .transform((value, originalValue) => originalValue ? originalValue.trim() : value)
    .test('min-length', MESSAGE_ERREUR_3CARACTERES_MINIMUM, (value) => !value || value.length >= 3)
    .defined(),
  EanIsbn: Yup
  .string()
  .transform((value, originalValue) => originalValue ? originalValue.trim() : value)
  .test('min-length', MESSAGE_ERREUR_3CARACTERES_MINIMUM, (value) => !value || value.length >= 3)
  .defined(),
  SortField: Yup
  .string()
  .transform((value, originalValue) => originalValue ? originalValue.trim() : value)
  .test('min-length', MESSAGE_ERREUR_3CARACTERES_MINIMUM, (value) => !value || value.length >= 3)
  .defined(),
}).partial();